export const Checkmark = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#706F78"
        fillRule="evenodd"
        d="M15.193 5.116c.304.199.39.607.19.91l-5.666 8.667a.658.658 0 0 1-.993.127l-3.667-3.333a.658.658 0 0 1 .885-.974l3.096 2.815 5.245-8.021a.658.658 0 0 1 .91-.191Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
